import ImageSettingsToolbar from './image-settings-toolbar.js'


export default function ImageSettings(pEditor, pImage)
{
  const pToolbar = this;

  this.ImageWrappingType =
  {
    ImageInlineWithText: 'ImageInlineWithText',
    ImageRightTextWrapsLeft: 'ImageRightTextWrapsLeft',
    ImageLeftTextWrapsRight: 'ImageLeftTextWrapsRight',
    ImageLeftTextBreaks: 'ImageLeftTextBreaks',
    ImageCenteredTextBreaks: 'ImageCenteredTextBreaks'
  };

  const idPrefix = `id_${pEditor.editorId}`;

  let image,
      params,
      toolbar,
      closeButton,
      pointer,
      buttons = {},
      linkCheckbox,
      contentareaSize,
      checkPositionTM = null;


  const initToolbar = () =>
  {
    toolbar = BEditor.domHelpers.$(`${idPrefix}_ImageSettingsToolbar`);

    closeButton = toolbar.querySelector('DIV[data-image-settings-toolbar-parse-tag="close"]');
    closeButton.addEventListener('click', this.hideToolbar, false);

    pointer = toolbar.querySelector('DIV[data-image-settings-toolbar-parse-tag="pointer"]');

    const buttonsElements = toolbar.querySelectorAll('DIV[data-image-settings-toolbar-parse-tag="button"]');

    for (let i = 0; i < buttonsElements.length; i++)
    {
      let name = buttonsElements[i].getAttribute('data-image-settings-toolbar-name');
      buttons[name] = new Button(name);
    }

    linkCheckbox = new Checkbox();
  };


  const createToolbar = () =>
  {
    const html = (new ImageSettingsToolbar(pEditor, pImage, this, { idPrefix })).renderToolbar();

    BEditor.environment.topWindow.document.body.insertAdjacentHTML('beforeend', html);

    initToolbar();
  };


  const setThemeColors = () =>
  {
    const themeStyles = BEditor.Config.getThemeStyles(),
          themeColors = (themeStyles && themeStyles.colors) ? themeStyles.colors : [],
          themeColorsCells = toolbar.querySelectorAll('DIV[data-image-settings-toolbar-parse-tag="ddThemeColorCell"]');

    for (let i = 0; i < themeColorsCells.length; i++)
    {
      if (themeColors[i])
      {
        let currentColor = (themeColors[i].indexOf('#') !== -1) ? themeColors[i].substr(themeColors[i].indexOf('#') + 1) : themeColors[i];
        themeColorsCells[i].setAttribute('data-image-settings-toolbar-border-color', currentColor);
        themeColorsCells[i].style.background = '#' + currentColor;
        themeColorsCells[i].style.cursor = 'crosshair';
      }
      else
      {
        themeColorsCells[i].removeAttribute('data-image-settings-toolbar-border-color');
        themeColorsCells[i].style.background = 'none';
        themeColorsCells[i].style.cursor = 'default';
      }
    }
  };


  const initView = () =>
  {
    calculatePosition();

    for (let k in buttons)
    {
      if (buttons.hasOwnProperty(k))
      {
        buttons[k].initView();
      }
    }

    linkCheckbox.initView();
  };


  const calculatePositionDo = () =>
  {
    if (checkPositionTM) clearTimeout(checkPositionTM);

    const windowSizes = BEditor.window.getWindowSizes(BEditor.environment.topWindow);
    const contentareaSize = (BEditor.environment.topWindow.contentarea ? BEditor.window.getWindowSizes(BEditor.environment.topWindow.contentarea) : { scrollTop: 0, scrollLeft: 0, altScrollTop: 0, altScrollLeft: 0 });
    const imageXY  = BEditor.dimensions.getElementAbsXY(image, pEditor.iFrame);

    pointer.style.left = Math.min((Math.floor(imageXY.width / 2) - 8), toolbar.offsetWidth - 30) + 'px';

    let top = imageXY.top - toolbar.offsetHeight - 23 - windowSizes.scrollTop - windowSizes.altScrollTop - contentareaSize.scrollTop - contentareaSize.altScrollTop,
        left = imageXY.left - windowSizes.scrollLeft - windowSizes.altScrollLeft - contentareaSize.scrollLeft - contentareaSize.altScrollLeft;

    if (left + toolbar.offsetWidth > windowSizes.clientWidth)
    {
      left -= left + (toolbar.offsetWidth - windowSizes.clientWidth);
    }

    toolbar.style.top = top + 'px';
    toolbar.style.left = left + 'px';

    checkPositionTM = setTimeout(calculatePositionDo, 17)
  };


  const calculatePosition = () =>
  {
    calculatePositionDo();
    toolbar.style.visibility = 'visible';
  };


  const addToolbarHandlers = () =>
  {
    BEditor.environment.topWindow.addEventListener('click', this.hideToolbar, false);

    if (BEditor.environment.topWindow.contentarea)
    {
      BEditor.environment.topWindow.contentarea.addEventListener('click', this.hideToolbar, false);
    }

    pEditor.iFrame.addEventListener('click', this.hideToolbar, false);
    toolbar.addEventListener('click', onToolbarClick, false);
  };


  const removeToolbarHandlers = () =>
  {
    BEditor.environment.topWindow.removeEventListener('click', this.hideToolbar, false);

    if (BEditor.environment.topWindow.contentarea)
    {
      BEditor.environment.topWindow.contentarea.removeEventListener('click', this.hideToolbar, false);
    }

    pEditor.iFrame.removeEventListener('click', this.hideToolbar, false);
    toolbar.removeEventListener('click', onToolbarClick, false);
  };


  const onToolbarClick = (e) =>
  {
    e.stopPropagation();
    //hideDropdowns();
  };


  const hideDropdowns = () =>
  {
    for (let k in buttons)
    {
      if (buttons.hasOwnProperty(k) && k !== name)
      {
        buttons[k].hideDropdown();
      }
    }
  };


  this.showToolbar = (newImage, newParams) =>
  {
    image = newImage;
    params = newParams;

    if (toolbar)
    {
      setThemeColors();
      initView();
    }

    setTimeout(addToolbarHandlers, 100);
  };


  this.hideToolbar = () =>
  {
    if (checkPositionTM) clearTimeout(checkPositionTM);

    if (toolbar)
    {
      hideDropdowns();

      toolbar.style.left = '-37000px';
      toolbar.style.top = '-37000px';
      toolbar.style.visibility = 'hidden';
    }

    removeToolbarHandlers();
  };


  function Button (name)
  {
    const objButtons = {};
    const container = toolbar.querySelector(`DIV[data-image-settings-toolbar-parse-tag="button"][data-image-settings-toolbar-name="${name}"]`);
    const label = container.querySelector(`DIV[data-image-settings-toolbar-parse-tag="label"]`);

    objButtons['Size'] = function ()
    {
      this.initView = () =>
      {
        label.innerHTML = `Size ${params.size.width}x${params.size.height} px`;
      };
    };

    objButtons['TextFlow'] = function ()
    {
      this.initView = () =>
      {
        label.setAttribute('data-image-settings-toolbar-appearance', `withIcon ${params.wrapping}`);
      };
    };

    objButtons['Margins'] = function ()
    {

    };

    objButtons['Borders'] = function ()
    {
      this.initView = () =>
      {
        label.innerHTML = `Borders ${params.borders.width} px`;
      };
    };

    objButtons['BordersColor'] = function ()
    {
      const colorContainer = label.querySelector(`DIV[data-image-settings-toolbar-parse-tag="selectedColor"]`);

      this.initView = () =>
      {
        colorContainer.style.backgroundColor = params.borders.color;
      };
    };

    objButtons['AltText'] = function ()
    {

    };

    const button = new objButtons[name];
    const dropdown = new Dropdown(name, container);

    let isPressed = false;


    const init = () =>
    {
      container.addEventListener('mouseover', onButtonOver, false);
      container.addEventListener('mouseout', onButtonOut, false);
      container.addEventListener('click', onButtonClick, false);
    };


    this.initView = () =>
    {
      if ('initView' in button)
      {
        button.initView();
      }

      dropdown.initView();
    };


    const onButtonOver = (e) =>
    {
      if (!isPressed)
      {
        container.setAttribute('data-image-settings-toolbar-state', 'hover');
      }
    };


    const onButtonOut = (e) =>
    {
      if (!isPressed)
      {
        container.removeAttribute('data-image-settings-toolbar-state');
      }
    };


    const onButtonClick = (e) =>
    {
      isPressed = !isPressed;

      if (isPressed)
      {
        for (let k in buttons)
        {
          if (buttons.hasOwnProperty(k) && k !== name)
          {
            buttons[k].hideDropdown();
          }
        }

        container.setAttribute('data-image-settings-toolbar-state', 'pressed');
        dropdown.show();
      }
      else
      {
        container.setAttribute('data-image-settings-toolbar-state', 'hover');
        dropdown.hide();
      }
    };


    this.hideDropdown = () =>
    {
      isPressed = false;
      container.removeAttribute('data-image-settings-toolbar-state');
      dropdown.hide();
    };


    init();
  }


  function Checkbox ()
  {
    const container = toolbar.querySelector(`DIV[data-image-settings-toolbar-parse-tag="checkbox"][data-image-settings-toolbar-name="Link"]`);
    const checkbox = container.querySelector(`INPUT[type="checkbox"]`);

    this.initView = () =>
    {
      checkbox.checked = params.addLinkToOriginal;
    };

    const onItemClick = () =>
    {
      params.addLinkToOriginal = checkbox.checked;
      pImage.ieditor.setImageProperty({ name: 'addLinkToOriginal', value: params });
    };

    container.addEventListener('click', onItemClick, false);
  }


  function Dropdown (name, buttonContainer)
  {
    const objDropdowns = {};
    const container = toolbar.querySelector(`DIV[data-image-settings-toolbar-parse-tag="dropdown"][data-image-settings-toolbar-name="${name}"]`);

    objDropdowns['Size'] = function ()
    {
      const label = container.querySelector(`DIV[data-image-settings-toolbar-parse-tag="ddItem"][data-image-settings-toolbar-name="Original"]`),
            inputWidth = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Width"]`),
            inputHeight = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Height"]`),
            checkbox = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="checkbox"][data-image-settings-toolbar-name="MaintainRatio"]`),
            checkboxContainer = checkbox.parentNode;

      this.initView = () =>
      {
        label.innerHTML = `Origin ${params.size.originalWidth}x${params.size.originalHeight} px`;
        inputWidth.value = params.size.width;
        inputHeight.value = params.size.height;
        checkbox.checked = params.size.keepRatio;
      };

      const calcImageSize = (sizeProportion) =>
      {
        const size = { height: 0, width: 0, isOriginal: false},
              contentWidth = params.size.contentWidth,
              originalWidth = params.size.originalWidth,
              originalHeight = params.size.originalHeight;

        if (sizeProportion)
        {
          if (originalWidth > contentWidth)
          {
            size.height = Math.round((contentWidth / 100 * sizeProportion) / originalWidth * originalHeight);
            size.width = contentWidth / 100 * sizeProportion;
            size.isOriginal = false;
          }
          else
          {
            size.height = originalHeight/100 * sizeProportion;
            size.width = originalWidth/100 * sizeProportion;
            size.isOriginal = true;
          }
        }
        else
        {
          size.height = originalHeight;
          size.width = originalWidth;
          size.isOriginal = true;
        }

        return size;
      };

      this.onItemClick = (command) =>
      {
        const sizeProportionsPercentage =
        {
          Original: null,
          Large: 100,
          Medium: 50,
          Small: 25,
        };

        let newSize = calcImageSize(sizeProportionsPercentage[command]);

        params.size.height = newSize.height;
        params.size.width = newSize.width;
        params.size.isOriginal = newSize.isOriginal;
        params.size.keepRatio = true;

        pImage.ieditor.setImageProperty({ name: 'size', value: params });
      };

      const onWidthChanged = () =>
      {
        let width = (!isNaN(parseInt(inputWidth.value))) ? parseInt(inputWidth.value) : null;

        if (width !== params.size.width)
        {
          params.size.width = width ? width : params.naturalWidth;
          objInputWidth.setValue(params.size.width);

          if (checkbox.checked)
          {
            params.size.height = Math.round(width / params.size.originalWidth * params.size.originalHeight);
            objInputHeight.setValue(params.size.height);
          }

          pImage.ieditor.setImageProperty({ name: 'size', value: params });
          initView();
        }
      };

      const onHeightChanged = () =>
      {
        let height = (!isNaN(parseInt(inputHeight.value))) ? parseInt(inputHeight.value) : null;

        if (height !== params.size.height)
        {
          params.size.height = height ? height : params.naturalHeight;
          objInputHeight.setValue(params.size.height);

          if (checkbox.checked)
          {
            params.size.width = Math.round(height / params.size.originalHeight * params.size.originalWidth);
            objInputWidth.setValue(params.size.width);
          }

          pImage.ieditor.setImageProperty({ name: 'size', value: params });
          initView();
        }
      };

      const objInputWidth = new TextBox(inputWidth, 'int', 1, onWidthChanged),
            objInputHeight = new TextBox(inputHeight, 'int', 1, onHeightChanged);

      const onCheckboxClick = () =>
      {
        params.size.keepRatio = checkbox.checked;
        pImage.ieditor.setImageProperty({ name: 'size', value: params });
        initView();
      };

      checkboxContainer.addEventListener('click', onCheckboxClick, false);
    };

    objDropdowns['TextFlow'] = function ()
    {
      this.onItemClick = (command) =>
      {
        params.wrapping = command;
        pImage.ieditor.setImageProperty({ name: 'wrapping', value: params });
      }
    };

    objDropdowns['Margins'] = function ()
    {
      const inputTop = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Top"]`),
            inputRight = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Right"]`),
            inputBottom = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Bottom"]`),
            inputLeft = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Left"]`);

      this.initView = () =>
      {
        inputTop.value = params.margins.top;
        inputRight.value = params.margins.right;
        inputBottom.value = params.margins.bottom;
        inputLeft.value = params.margins.left;
      };

      this.onItemClick = (command) =>
      {
        params.margins.top = params.margins.right = params.margins.bottom = params.margins.left = (!isNaN(parseInt(command))) ? parseInt(command) : null;
        pImage.ieditor.setImageProperty({ name: 'margins', value: params });
      };

      const onMarginChanged = (dir) =>
      {
        const directionals =
        {
          'Top': { element: inputTop, property: 'top' },
          'Right': { element: inputRight, property: 'right' },
          'Bottom': { element: inputBottom, property: 'bottom' },
          'Left': { element: inputLeft, property: 'left' }
        };

        const margin = (!isNaN(parseInt(directionals[dir].element.value))) ? parseInt(directionals[dir].element.value) : null;

        if (margin !== params.margins[directionals[dir].property])
        {
          params.margins[directionals[dir].property] = margin;
          pImage.ieditor.setImageProperty({ name: 'margins', value: params });
          initView();
        }
      };

      const objInputTop = new TextBox(inputTop, 'int', null, () => { onMarginChanged('Top') }),
            objInputRight = new TextBox(inputRight, 'int', null, () => { onMarginChanged('Right') }),
            objInputBottom = new TextBox(inputBottom, 'int', null, () => { onMarginChanged('Bottom') }),
            objInputLeft = new TextBox(inputLeft, 'int', null, () => { onMarginChanged('Left') });
    };

    objDropdowns['Borders'] = function ()
    {
      const bordersWidth = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="BordersWidth"]`);

      this.initView = () =>
      {
        bordersWidth.value = params.borders.width;
      };

      this.onItemClick = (command) =>
      {
        params.borders.width = (!isNaN(parseInt(command))) ? parseInt(command) : null;
        pImage.ieditor.setImageProperty({ name: 'borders', value: params });
      };

      const onBordersWidthChanged = () =>
      {
        const width = (!isNaN(parseInt(bordersWidth.value))) ? parseInt(bordersWidth.value) : null;

        if (width !== params.borders.width)
        {
          params.borders.width = width;
          pImage.ieditor.setImageProperty({ name: 'borders', value: params });
          initView();
        }
      };

      const objBordersWidth = new TextBox(bordersWidth, 'int', 0, onBordersWidthChanged);
    };

    objDropdowns['BordersColor'] = function ()
    {
      const bordersColor = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="Color"]`),
            previewColor = container.querySelector(`DIV[data-image-settings-toolbar-parse-tag="previewColor"]`),
            buttonSelect = container.querySelector(`DIV[data-image-settings-toolbar-parse-tag="ddButton"][data-image-settings-toolbar-name="Select"]`);

      this.initView = () =>
      {
        bordersColor.value = params.borders.color.substr(1);
        previewColor.style.backgroundColor = params.borders.color;
      };

      this.onItemClick = (e) =>
      {
        const element = e.target,
              parseTag = element.getAttribute('data-image-settings-toolbar-parse-tag');

        if (parseTag === 'ddThemeColorCell' || parseTag === 'ddColorCell')
        {
          const color = element.getAttribute('data-image-settings-toolbar-border-color');

          if (color != null)
          {
            bordersColor.focus();
            bordersColor.value = color;
          }
        }
      };

      container.addEventListener('click', this.onItemClick, false);
      buttonSelect.addEventListener('click', hide, false);

      const onBordersColorChanged = () =>
      {
        const color = bordersColor.value;

        if (color !== params.borders.color)
        {
          params.borders.color = `#${color}`;
          pImage.ieditor.setImageProperty({ name: 'borders', value: params });
          initView();
        }
      };

      const objBordersColor = new TextBox(bordersColor, 'color', 0, onBordersColorChanged);
    };

    objDropdowns['AltText'] = function ()
    {
      const altText = container.querySelector(`INPUT[data-image-settings-toolbar-parse-tag="field"][data-image-settings-toolbar-name="AltText"]`);

      this.initView = () =>
      {
        altText.value = params.altText;
      };

      const onAltTextChanged = () =>
      {
        const text = altText.value;

        if (text !== params.altText)
        {
          params.altText = text;
          pImage.ieditor.setImageProperty({ name: 'altText', value: params });
          initView();
        }
      };

      const objAltText = new TextBox(altText, 'str', 0, onAltTextChanged);
    };

    const dropdown = new objDropdowns[name];
    const ddItems = container.querySelectorAll('DIV[data-image-settings-toolbar-parse-tag="ddItem"]');

    let isShow = false;


    const onItemClick = (e) =>
    {
      hideDropdowns();

      const ddItem = e.currentTarget;

      if (!ddItem)
      {
        return false;
      }

      const command = ddItem.getAttribute('data-image-settings-toolbar-name');

      if (command && 'onItemClick' in dropdown)
      {
        dropdown.onItemClick(command);
      }

      initView();
    };


    const init = () =>
    {
      for (let i = 0; i < ddItems.length; i++)
      {
        ddItems[i].addEventListener('click', onItemClick, false);
      }
    };


    this.initView = () =>
    {
      if ('initView' in dropdown)
      {
        dropdown.initView();
      }
    };


    this.show = () =>
    {
      isShow = true;
      initView();

      const windowSizes = BEditor.window.getWindowSizes(BEditor.environment.topWindow);
      const toolbarXY = BEditor.dimensions.getElementXY(toolbar);
      const buttonContainerTop = buttonContainer.offsetTop;
      let top = buttonContainerTop + buttonContainer.offsetHeight;

      if (toolbarXY.top + top + container.offsetHeight > windowSizes.clientHeight && buttonContainerTop - container.offsetHeight > 0)
      {
        top = buttonContainerTop - container.offsetHeight;
      }

      let left = buttonContainer.offsetLeft;

      if (toolbarXY.left + left + container.offsetWidth > windowSizes.clientWidth)
      {
        left -= toolbarXY.left + left + container.offsetWidth - windowSizes.clientWidth;
      }

      container.style.top = top + 'px';
      container.style.left = left + 'px';
      container.style.visibility = 'visible';
    };


    this.hide = () =>
    {
      hide();
    };

    function hide()
    {
      isShow = false;
      container.style.top = '-37000px';
      container.style.left = '-37000px';
      container.style.visibility = 'hidden';
    }


    function TextBox(input, type, min, handler)
    {
      let prevValue = null,
          validateValueTM = null,
          checkValueTM = null;

      const onFocus = () =>
      {
        prevValue = input.value;

        if (type !== 'str')
        {
          input.addEventListener('keypress', onKeyPress);
          if (validateValueTM) clearInterval(validateValueTM);
          validateValueTM = setInterval(validateValue, 17);
        }

        if (checkValueTM) clearInterval(checkValueTM);
        checkValueTM = setInterval(checkValue, 250);
      };

      const onBlur = () =>
      {
        if (type !== 'str')
        {
          input.removeEventListener('keypress', onKeyPress);
          if (validateValueTM) clearInterval(validateValueTM);
        }

        if (checkValueTM) clearInterval(checkValueTM);
        checkValue();
      };

      const onKeyPress = (e) =>
      {
        let valid = `${(type === 'int') ? (min == null) ? '-' : '' : (type === 'color') ? 'AaBbCcDdEeFf' : ''}0123456789`,
            key = (e.key != null) ? e.key : (e.keyCode != null) ? String.fromCharCode(e.keyCode) : null;

        if (key != null && !e.ctrlKey && !e.altKey)
        {
          if (valid.indexOf(key) === -1)
          {
            e.preventDefault();
          }
        }
      };

      const validateValue = () =>
      {
        const reValid = (type === 'int') ? (min != null) ? /[^0-9]/g : /[^-0-9]/g : (type === 'color') ? /[^0-9A-F]/ig : /[]/g;
        let value = input.value;

        if (reValid.test(value))
        {
          value = value.replace(reValid, '');
        }

        if (min == null && value.indexOf('-', value.length) > 0)
        {
          value = value.substr(0, 1) + value.substr(1).replace(/-/g, '');
        }

        if (min != null && value < min)
        {
          value = '' + min;
        }

        if (input.value !== value)
        {
          input.value = value;
        }
      };

      const checkValue = () =>
      {
        if (input.value !== prevValue)
        {
          if (type !== 'str')
          {
            validateValue();
          }

          handler(this);
          prevValue = input.value;
        }
      };

      this.setValue = (value) =>
      {
        input.value = value;
        prevValue = input.value;
      };

      input.addEventListener('focus', onFocus);
      input.addEventListener('blur', onBlur);
    }


    init();
  }

  createToolbar();
}